import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { cvStyles } from '../cvStyles';
import { formatDate } from '../../hooks/useExperiences';
import { cvConfig } from '../cvConfig';

/**
 * Componente de Experiencias del CV
 * Muestra el historial laboral
 */
export const CVExperience = ({ experiences }) => {
  if (!experiences || experiences.length === 0) return null;

  // Limitar cantidad de experiencias según configuración
  const limitedExperiences = experiences.slice(0, cvConfig.limits.maxExperiences);

  return (
    <View style={cvStyles.section}>
      <Text style={cvStyles.sectionTitle}>Experiencia Laboral</Text>
      
      {limitedExperiences.map((company, companyIndex) => (
        <View key={companyIndex} style={cvStyles.experienceItem}>
          {/* Información de la empresa */}
          <View style={cvStyles.experienceHeader}>
            <View>
              <Text style={cvStyles.experienceCompany}>{company.company}</Text>
            </View>
          </View>
          <Text style={cvStyles.experienceDuration}>
            Duración total: {company.totalDuration}
          </Text>

          {/* Proyectos/Posiciones en la empresa */}
          {company.projects.map((project, projectIndex) => (
            <View key={projectIndex} style={{ marginTop: projectIndex > 0 ? 10 : 8 }}>
              <View style={[cvStyles.row, cvStyles.spaceBetween]}>
                <Text style={cvStyles.experienceTitle}>{project.position}</Text>
                <Text style={cvStyles.experienceDate}>
                  {formatDate(project.startDate)} - {formatDate(project.endDate)}
                </Text>
              </View>

              {project.workType && (
                <Text style={[cvStyles.experienceDate, { marginTop: 2 }]}>
                  {project.workType}
                </Text>
              )}

              {project.description && (
                <Text style={cvStyles.experienceDescription}>
                  {project.description}
                </Text>
              )}

              {project.habilities && project.habilities.length > 0 && (
                <View style={cvStyles.experienceTechnologies}>
                  {project.habilities.map((tech, techIndex) => (
                    <Text key={techIndex} style={cvStyles.technologyTag}>
                      {tech}
                    </Text>
                  ))}
                </View>
              )}
            </View>
          ))}
        </View>
      ))}
    </View>
  );
};
